//
//
//
//
//
//
//
//

import htmlParser from '~/mixins/htmlParser';

export default {
    mixins: [htmlParser],
    props: {
        text: {
            type: String | undefined,
            required: false,
            default: '',
        },
        maxLength: {
            type: Number,
            required: false,
            default: 255,
        },
    },
    data: () => ({
        extended: false,
    }),
    computed: {
        renderedText() {
            const fullText = this.text ? this.extractTextFromHtml(this.text) : '';
            const sentences = fullText.split('. ');

            if (!this.extended && sentences.length > 1) {
                return sentences.reduce(this.concatUnderMaxLength(this.maxLength));
            } else {
                return fullText;
            }
        },
    },
    methods: {
        extend() {
            this.extended = true;
        },
        extractTextFromHtml(html) {
            return this.parseTextFromHTML(html);
        },
        concatUnderMaxLength(maxLength) {
            return (result, sentence) => {
                const extendedResult = `${result}. ${sentence}.`;

                if (extendedResult.length <= maxLength) {
                    return extendedResult;
                }

                return result;
            };
        },
    },
};
